<template lang="pug">
k-main.admin-edit-base
  template( #title )
    .title
      h1.title {{ title }}
      k-actions.header-actions( :actions='actions' :icons='icons' )
  .main-content( v-if='post.sections' v-bar )
    .inner
  .main-content( v-else )
  k-actions.footer-actions(
    :actions='actions'
    :icons='icons'
    type='icon-text'
  )
</template>

<script lang="js">
import { mapState, mapActions } from 'vuex'
import KActions from '@/blocks/k-actions'
import KMain from '@/blocks/k-main'
import icons from '@/icons'

export default {
  name: 'AdminEditBasePage',
  mixins: [],
  components: { KActions, KMain },
  props: {
    post: {
      type: Object,
      default: () => ({})
    },
    model: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      icons
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    // ...mapState([ 'post' ]),
    actions() {
      return ( this.post && this.post.actions ) || []
    },
    sections() {
      return this.thisSections || ( this.post && this.post.sections ) || []
    },
    objects() {
      return  this.thisObjects || ( this.post && this.post.objects ) || []
    },
    title() {
      return ( this.post && this.post.title ) || 'Content'
    }
  }
}
</script>

<style lang="scss">
.admin-edit-base {

}
</style>
